<template>
  <v-container fluid>
    <div id="app">
      <v-app id="inspire">
        <!--Signupg Title-->
        <v-layout row wrap>
          <v-row align="center" justify="center">
            <v-col cols="auto" md="auto">
              <v-flex sm="15">
                <h1>Your Profile: {{ user.userName }}</h1>
              </v-flex>
            </v-col>
          </v-row>
        </v-layout>

        <!--Error Alert-->
        <v-layout v-if="error">
          <v-flex xs12 sm6 offset-sm3>
            <form-alert :message="error.message"></form-alert>
          </v-flex>
        </v-layout>
        <v-alert v-else-if="!hasUser" border="top" color="red" type="warning">
          You need to signin
        </v-alert>
        <v-layout v-else row wrap>
          <v-flex xs12 sm6 offset-sm3>
            <v-card color="accent" dark max-width="344" class="mx-auto">
              <v-container>
                <v-form
                  v-model="isFormValid"
                  lazy-validation
                  ref="form"
                  @submit.prevent="handleSignupUser"
                >
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        :rules="userEmailRules"
                        v-model="user.userEmail"
                        prepend-icon="mail"
                        readonly
                        label="User Email"
                        type="text"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :rules="userEmailRules"
                        v-model="user.userEmail"
                        prepend-icon="account_circle"
                        autocomplete="email"
                        label="User Name"
                        type="text"
                        readonly
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        id="profile_real_name"
                        :rules="userNameRules"
                        v-model="user.userName"
                        prepend-icon="face"
                        label="Real Name"
                        hint="Will be shown in all statistics"
                        type="text"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="user.gender"
                        :items="['male', 'female']"
                        label="Gender"
                        :rules="requiredRule"
                        prepend-icon="gender"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            id="profile_Birth_Date"
                            v-model="user.birthDate"
                            label="Birth Date"
                            prepend-icon="event"
                            v-on="on"
                            readonly
                            :menu-props="{ contentClass: 'birthdate-selector' }"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          id="profile_Birth_Date-datepicker"
                          v-model="user.birthDate"
                          @input="menu = false"
                          :menu-props="{ contentClass: 'birthday-datepicker' }"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="user.createDate"
                        readonly
                        prepend-icon="event"
                        label="Create Date"
                        type="text"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        :rules="passwordRules"
                        v-model="password"
                        prepend-icon="extension"
                        label="Password"
                        type="password"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        :rules="passwordRules"
                        v-model="passwordConfirmation"
                        prepend-icon="gavel"
                        label="Confirm Password"
                        type="password"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row>
                    <v-flex xs12>
                      <v-btn
                        :loading="loading"
                        :disabled="!isFormValid || loading"
                        color="info"
                        type="submit"
                      >
                        <span slot="loader" class="custom-loader">
                          <v-icon light>cached</v-icon>
                        </span>
                        Save Changes
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-app>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      userEmail: "",
      menu: false,
      password: "",
      passwordConfirmation: "",
      userName: "",
      isFormValid: true,
      userNameRules: [
        userName => !!userName || "User Name is required",
        userName =>
          userName.length < 50 || "Username can not be more than 50 characters"
      ],
      userEmailRules: [
        v => !!v || "E-mail is required",
        v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid" // eslint-disable-line
      ],
      requiredRule: [v => !!v || "Value is required"],
      passwordRules: [
        //   password => !!password || 'Password is required',
        //   password => password.length >= 4 || "Password must be at least 4 characters",
        confirmation => confirmation === this.password || "Passwords must match"
      ]
    };
  },

  computed: {
    ...mapGetters(["loading", "error", "user", "hasUser"])
  },
  mounted() {},

  watch: {
    user(value) {
      //
      // if user value changes б redirect to home page
      if (value) {
        this.$router.push("/landing");
      }
    }
  },
  methods: {
    handleSignupUser() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("signUpUser", {
          userName: this.user.userName,
          userEmail: this.user.userEmail,
          birthDate: this.user.birthDate,
          gender: this.user.gender,
          password: this.password ? this.password : this.user.password,
          updateSource: "OlympianGuruApp"
        });
      }
    }
  }
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
